module.exports = __webpack_public_path__ + "img/away.ffa0d55c.jpeg";